// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"d1dc2986","419":"5e71d47f","563":"9055b918","787":"f9963773","942":"1cdbe045"}[chunkId] + ".chunk.js";
};